export const ReportVI = {
    "Title":{
        "reportListPersonnel" : "Danh sách báo cáo nhân sự",
        "nameReport" : "Tên báo cáo",
        "personnelRecord" : "Hồ sơ nhân sự",
        "personnelChange" : "Biến động nhân sự",
        "gender" : "Giới tính",
        "age" : "Độ tuổi",
        "academicLevel" : "Trình độ nhấn sự",
        "laborContract" : "Hợp đồng",
        "contractType" : "Loại hợp đồng",
        "insurance" : "Bảo hiểm",
        "monthly" : "Theo tháng",
        "decision" : "Quyết định",
        "bonus" : "Khen thưởng",
        "laborDiscipline" : "Kỷ luật lao động",
        "disciplineIsOutstanding" : "Kỷ luật nội bộ",
        "decidedToIncrease" : "Quyết định tăng lương",
        "decisionDepartment" : "Quyết định điều chuyển phòng ban",
        "welfareReport" : "Báo cáo phúc lợi",
        "codeNV" : "Mã NV",
        "personnel" : "Nhân sự",
        "department" : "Phòng ban ",
        "jobPosition" : "Vị trí",
        "jobTitle" : "Chức vụ",
        "amountOfMoney" : "Số tiền",
        "dateOfEnjoyment" : "Ngày hưởng",
        "type" : "Hình thức",
        "reasonError": "Lỗi vi phạm ",
        "creatDate" : "Ngày tạo ",
        "rangDate" : "Ngày vi phạm ",
        "money" : "Tiền vi phạm",
        "decisionMaker" : "Cấp ra quyết định",
        "moneyBonus" : "Tiền thưởng",
        "effectiveDate" : "Ngày hiệu lực",
        "disciplinaryDay" : "Ngày kỷ luật",
        "curDepartment" : "Phòng ban cũ ",
        "curJobPosition" : "Vị trí cũ",
        "curJobTitle" : "Chức vụ cũ",
        "newDepartment" : "Phòng ban mới",
        "newJobPosition" : "Vị trí mới",
        "newJobTitle" : "Chức vụ mới",
    }
}